import React from 'react'
import { Route, Switch, Redirect, RouteComponentProps } from 'react-router-dom'
import TeamData from './TeamData'
import MyData from './UStudyData'
import PersonData from './MyData'
import { ComponentExt } from 'util/reactExt'

const routeMap = [
  { name: 'my', pathname: 'my', component: MyData },
  { name: 'personData', pathname: 'person', component: PersonData },
  { name: 'teamData', pathname: 'team', component: TeamData },
]

export interface UserDataProps extends RouteComponentProps<any> {}

class UserCenter extends ComponentExt<UserDataProps, any> {
  public render() {
    return (
      <div>
        <div>
          <section>
            <Switch>
              {routeMap.map((tab, i) => (
                <Route
                  key={i}
                  path={`/usercenter/data/${tab.pathname}`}
                  component={tab.component}
                />
              ))}
              <Redirect to={`/usercenter/data/${routeMap[0].pathname}`} />
            </Switch>
          </section>
        </div>
      </div>
    )
  }
}

export default UserCenter
